/**
 * DpFundamentalChartService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DpFundamentalChartService {
    getFundamentalChartData = (body) => {
        return apiClient.post("/dataProcessing/fundamentalchart", body);
    }

    createFundamentalChartData = (body) => {
        return apiClient.post("/dataProcessing/fundamentalchart/create", body);
    }

    editFundamentalChartData = (body) => {
        return apiClient.post("/dataProcessing/fundamentalchart/update", body);
    }

    deleteFundamentalChartData = (id) => {
        return apiClient.post("/dataProcessing/fundamentalchart/delete", { id });
    }
}
